import { useEffect } from "react";
import { matchPath } from "react-router-dom";
import { ROUTES } from "./routes";

export const PRODUCT_NAME = "Job Envoy";

/** A page's name, then the product's, as the tab shows it. */
export function pageTitle(name: string): string {
    return `${name} · ${PRODUCT_NAME}`;
}

/**
 * Each page's name, as the header labels it. The legal names are
 * the documents' own titles, written out so the main bundle does not
 * carry the documents.
 */
const NAMES: ReadonlyArray<readonly [path: string, name: string]> = [
    [ROUTES.HOME, "Jobs"],
    [ROUTES.OVERVIEW, "Overview"],
    [ROUTES.ENVOY, "Your envoy"],
    [ROUTES.OPENINGS, "Jobs"],
    [ROUTES.JOBS, "Jobs"],
    [ROUTES.QUEUE, "Applications"],
    [ROUTES.APPLICATIONS, "Applications"],
    [ROUTES.HISTORY, "Application history"],
    [ROUTES.SAVED, "Saved"],
    [ROUTES.RESUME, "Resume"],
    [ROUTES.RESUME_EDIT, "Edit your resume"],
    [ROUTES.RESUME_WORK, "Work and self-ID"],
    [ROUTES.ACCOUNT, "Account"],
    [ROUTES.PRICING, "Pricing"],
    [ROUTES.SUPPORT, "Support"],
    [ROUTES.EMAIL_CHOICES, "Email choices"],
    [ROUTES.PRIVACY, "Privacy policy"],
    [ROUTES.TERMS, "Terms of service"],
    [ROUTES.TOOLS, "Free job search tools"],
    [ROUTES.RESUME_CHECK, "Free Resume Keyword Checker"],
];

/**
 * The tab's title for an app address. Null for a posting, its check page
 * or a company, which name themselves once loaded (`usePageTitle`), and
 * the product's name alone for an address no page answers.
 */
export function appTitle(pathname: string): string | null {
    // The named pages first: Saved, at /jobs/saved, has the shape of a posting's address.
    const found = NAMES.find(([path]) => matchPath(path, pathname));
    if (found) return pageTitle(found[1]);
    if (matchPath(ROUTES.POSTING_DETAIL, pathname)) return null;
    if (matchPath(ROUTES.RESUME_CHECK_POSTING, pathname)) return null;
    if (matchPath(ROUTES.COMPANY, pathname)) return null;
    return PRODUCT_NAME;
}

/** Sets the tab's title while the caller is mounted. Null leaves it as it is. */
export function usePageTitle(title: string | null): void {
    useEffect(() => {
        if (title !== null) document.title = title;
    }, [title]);
}
